'use strict';

exports.__esModule = true;
exports.getTokenByDashboardId = getTokenByDashboardId;
exports.getTokenByDashboardIdUNSAFE = getTokenByDashboardIdUNSAFE;

var _gateway = require('../network/gateway');

var _gateway2 = _interopRequireDefault(_gateway);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENDPOINTS = {
  getTokenByDashboardId: '/reports/token',
  getTokenByDashboardIdUNSAFE: '/reports/token/unsafe'
};

var Reports = {
  getTokenByDashboardId: getTokenByDashboardId,
  getTokenByDashboardIdUNSAFE: getTokenByDashboardIdUNSAFE
};

exports.default = Reports;

/**
 * Wrapper for `/reports/token` API endpoint
 * @return the metabase token for the dashboard
 * @param dashboardId the id of the metabase dashboard you want to embed into the web application
 */

function getTokenByDashboardId(dashboardId) {
  var dashboardUserKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

  return _gateway2.default.get({
    route: ENDPOINTS.getTokenByDashboardId + '/' + dashboardId + '?userKey=' + dashboardUserKey,
    includeAuth: true
  });
}

// TODO: Find a better way to handle Alshayaa custom report
/**
 * ! WARNING ! DO NOT USE THIS ENDPOINT IF UNCERTAIN
 * Wrapper for `/reports/token/unsafe` API endpoint
 * @return the metabase token for the dashboard WITHOUT signed filtering on user id
 * @param dashboardId the id of the metabase dashboard you want to embed into the web application
 */
function getTokenByDashboardIdUNSAFE(dashboardId) {
  return _gateway2.default.get({
    route: ENDPOINTS.getTokenByDashboardIdUNSAFE + '/' + dashboardId,
    includeAuth: true
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/gateway/reports.js
// module id = 1206
// module chunks = 0